export default {
    patient:[
        {
            id:"firsName",
            placeholder:abraStr.firstName,
            type:"input",
            classes:""
        },
        {
            id:"lastName",
            placeholder:abraStr.lastName,
            type:"input",
            classes:""
        },
        {
            id:"id",
            placeholder:abraStr.id,
            type:"input",
            classes:"full"
        },
        {
            id:"gender",
            placeholder:abraStr.gender,
            type:"select",
            classes:"",
            options:[abraStr.male,abraStr.female]
        },
        {
            id:"birth",
            placeholder:abraStr.birth,
            type:"input",
            classes:"",
        }
    ],
    doctor:[
        {
            id:"docFirsName",
            placeholder:abraStr.firstName,
            type:"input",
            classes:""
        },
        {
            id:"docLastName",
            placeholder:abraStr.lastName,
            type:"input",
            classes:""
        },
        {
            id:"docEmail",
            placeholder:abraStr.email,
            type:"input",
            classes:""
        },
        {
            id:"country",
            placeholder:abraStr.country,
            type:"select",
            classes:""
        }
    ]
};